import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ServicesPage() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-lightbulb-line',
      title: t('services.card1.title'),
      desc: t('services.card1.desc'),
      detail1: t('services.card1.detail1'),
      detail2: t('services.card1.detail2'),
      image: 'https://public.readdy.ai/ai/img_res/c0c143c2e156c3d2c20523b03fd5f584.jpg'
    },
    {
      icon: 'ri-truck-line',
      title: t('services.card2.title'),
      desc: t('services.card2.desc'),
      detail1: t('services.card2.detail1'),
      detail2: t('services.card2.detail2'),
      image: 'https://readdy.ai/api/search-image?query=equipment%20supply%20logistics%20warehouse%20technology%20hardware%20inventory%20professional%20organized%20storage%20facility%20modern%20clean%20corporate%20environment%20boxes%20and%20equipment&width=600&height=400&seq=service-logistics-001&orientation=landscape'
    },
    {
      icon: 'ri-settings-3-line',
      title: t('services.card3.title'),
      desc: t('services.card3.desc'),
      detail1: t('services.card3.detail1'),
      detail2: t('services.card3.detail2'),
      image: 'https://readdy.ai/api/search-image?query=system%20integration%20installation%20commissioning%20server%20rack%20network%20equipment%20cable%20management%20professional%20technician%20working%20data%20center%20clean%20organized%20infrastructure&width=600&height=400&seq=service-integration-001&orientation=landscape'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('services.card4.title'),
      desc: t('services.card4.desc'),
      detail1: t('services.card4.detail1'),
      detail2: t('services.card4.detail2'),
      image: 'https://readdy.ai/api/search-image?query=technical%20support%20training%20warranty%20service%20professional%20team%20helping%20customer%20modern%20office%20technology%20assistance%20clean%20corporate%20environment%20friendly%20service&width=600&height=400&seq=service-support-001&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <h1 className="text-5xl lg:text-6xl font-bold text-black leading-tight mb-8">
            {t('nav.services')}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl leading-relaxed mb-6">
            {t('services.title')}
          </p>
          <p className="text-base text-gray-600 max-w-4xl leading-relaxed">
            {t('services.intro')}
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {services.map((service, index) => (
              <div key={index} className="service-detail-card bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="h-64 w-full overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-8">
                  <div className="w-12 h-12 flex items-center justify-center mb-4">
                    <i className={`${service.icon} text-4xl text-[#1E3A8A]`}></i>
                  </div>
                  <h3 className="text-2xl font-semibold text-black mb-4">{service.title}</h3>
                  <p className="text-base text-gray-700 leading-relaxed mb-4">{service.desc}</p>
                  <p className="text-sm text-gray-600 leading-relaxed mb-3">{service.detail1}</p>
                  <p className="text-sm text-gray-600 leading-relaxed">{service.detail2}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
